import { useTranslation } from "react-i18next";
import { Box, Typography, Fade } from "@mui/material";
import AppBackground from "../components/layout/AppBackground";

export default function PrivacyPolicy() {
  const { t } = useTranslation("legal");

  return (
    <Fade in timeout={700}>
      <AppBackground
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
         <Box
          sx={{
            maxWidth: "900px",
            width: "100%",
            background: "rgba(26, 8, 32, 0.82)",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "white",
            borderRadius: "28px",
            boxShadow: "0 30px 80px rgba(0,0,0,0.45)",
            px: { xs: 3, sm: 4, md: 7 },
            py: { xs: 4, sm: 5, md: 7 },
            backdropFilter: "blur(14px)",
          }}
        >
          <Typography
            variant="overline"
            sx={{
              display: "inline-flex",
              width: "fit-content",
              px: 1.5,
              py: 0.05,
              borderRadius: "999px",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#e9dafd",
              fontSize: "0.82rem",
              fontWeight: 700,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              mb: 1.5,
            }}
          >
            {t("terms.kicker")}
          </Typography>

          <Typography variant="h4" gutterBottom sx={{ color: "white" }}>

            {t("privacy.title")}
          </Typography>

          <Typography variant="subtitle2" gutterBottom sx={{ color: "#ccc" }}>
            {t("privacy.lastUpdated")}
          </Typography>

          <Typography paragraph sx={{ color: "#fff" , mt: 4, mb: 4  }}>{t("privacy.intro")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section1.title")}
          </Typography>

          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section1.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section2.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section2.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section3.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section3.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section4.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section4.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section5.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section5.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section6.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section6.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section7.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section7.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section8.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section8.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section9.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section9.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section10.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section10.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section11.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section11.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section12.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section12.content")}</Typography>

          <Typography sx={{ fontSize: { xs: "1.25rem", md: "1.4rem" }, fontWeight: 800, lineHeight: 1.2, mt: 4.5, mb: 1.5,}}>
            {t("privacy.section13.title")}
          </Typography>
          <Typography paragraph sx={{color: "rgba(208, 202, 202, 0.92)"}}>{t("privacy.section13.content")}</Typography>

        </Box>
      </AppBackground>
    </Fade>
  );
}